const body = document.querySelector('body')
const mainDiv = document.querySelector('.main')
const boxMaisAcessados = document.querySelector('.overlayBusca__maisAcessados')
//const abrirSidebarOverlay = document.querySelectorAll('.abrir-sidebar-overlay')
//const overlayAside = document.querySelector('.overlayAside')
const overlayAjuda = document.querySelector('.overlayAjuda')
//const btnFecharOverlayAside = document.querySelector('.overlayAside__fechar')
const btnFecharOverlayAjuda = document.querySelector('.overlayAjuda__fechar')
const contentOverlaySidebar = document.querySelector('.overlayAside__content')
const checkCiente = document.querySelector('[data-js="check-ciente"]')
const btnProsseguirLogin = document.querySelector('[data-js="botao-prosseguir-login"]')
const btnAbrirAjuda = document.querySelectorAll('[data-js="botao-abrir-ajuda"]')

/*const overlaySidebarContent = [
  {
    logo: '/assets/img/logo-oficio-eletronico.svg',
    texto:
      'Resumo rápido do que é o Ofício Eletrônico, lorem ipsum dolor sit, sadipscing elitr, sed diam nonumy eirmod tempor invidunt sit, sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut. dolor sit, sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut. dolor sit, sadipscing elitr, sed diam nonumy eirmod tempor invidunt.',
        url: 'http://www.oficioeletronico.com.br/'
  },
  {
    logo: '/assets/img/penhora-logo.svg',
    texto:
      'Resumo rápido do que é o Ofício Eletrônico, lorem ipsum dolor sit, sadipscing elitr, sed diam nonumy eirmod tempor invidunt sit, sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut. dolor sit, sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut. dolor sit, sadipscing elitr, sed diam nonumy eirmod tempor invidunt.',
      url: 'http://www.penhoraonline.org.br/'
  },
  {
    logo: '/assets/img/onr-logo-texto.svg',
    texto:
      'Resumo rápido do que é o Ofício Eletrônico, lorem ipsum dolor sit, sadipscing elitr, sed diam nonumy eirmod tempor invidunt sit, sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut. dolor sit, sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut. dolor sit, sadipscing elitr, sed diam nonumy eirmod tempor invidunt.',
      url: 'https://onr.org.br/'
  }
]*/

function handleOpenSidebarOverlay(e) {
  e.preventDefault()

  const data = this.getAttribute('data-js')

  body.classList.add('overlaySidebarActive')
  overlayAside.classList.add('active')

  if(data === 'oficio') {
    const template = `      
      <img src='${overlaySidebarContent[0].logo}' alt='Logo' />
      <p>${overlaySidebarContent[0].texto}</p>
      <a class='botao botao--large' href='${overlaySidebarContent[0].url}' target="_blank">
        Visite o site
      </a>      
    `
    contentOverlaySidebar.innerHTML = template
    return false
  }

  if(data === 'penhora') {
    const template = `      
      <img src='${overlaySidebarContent[1].logo}' alt='Logo' />
      <p>${overlaySidebarContent[1].texto}</p>
      <a class='botao botao--large' href='${overlaySidebarContent[1].url}'>
        Visite o site
      </a>      
    `
    contentOverlaySidebar.innerHTML = template
    return false
  }

  if (data === 'onr') {
    const template = `      
      <img src='${overlaySidebarContent[2].logo}' alt='Logo' />
      <p>${overlaySidebarContent[2].texto}</p>
      <a class='botao botao--large' href='${overlaySidebarContent[2].url}'>
        Visite o site
      </a>      
    `
    contentOverlaySidebar.innerHTML = template
    return false
  }

}

function handleCloseSidebarOverlay() {
  body.classList.remove('overlaySidebarActive')
  overlayAside.classList.remove('active')
  contentOverlaySidebar.innerHTML = ''
}

function handleToggleCiente() {
  if (this.checked) {    
    btnProsseguirLogin.removeAttribute('disabled')
  } else {    
    btnProsseguirLogin.setAttribute('disabled', true)
  }
}

function handleOpenOverlayAjuda(e) {
  e & e.preventDefault()
  body.classList.add('overlaySidebarActive')
  overlayAjuda.classList.add('active')
}

function handleCloseSidebarAjuda() {
  body.classList.remove('overlaySidebarActive')
  overlayAjuda.classList.remove('active')
}

function ShowLoading(e) {    
    var maskHeight = $(document).height();
    var maskWidth = $(window).width();
    $('#mask').css({ 'width': maskWidth, 'height': maskHeight });

    var idDivLoading = "loading";
    var div = "<div id='" + idDivLoading + "'><img src='/Images/loading.svg'></div>";
    $("body").append(div);
    $("body").addClass('hidden-y-overflow');

    var winH = $(window).height();
    var winW = $(window).width();
    $("#" + idDivLoading).css('top', winH / 2 - $("#" + idDivLoading).height() / 2);
    $("#" + idDivLoading).css('left', winW / 2 - $("#" + idDivLoading).width() / 2);

    $('#mask').fadeTo("slow", 0.8);
    $("#" + idDivLoading).fadeIn(1000);

    $(document).on("mousedown", "selector", function (e) {
        if (e.which == 2) {
            e.preventDefault();
            return false;
        }
    });
} 

function DestroyLoading(onlyLoading) {
    if (!onlyLoading) $("#mask").hide();
    $("#loading").remove();
    $("body").removeClass('hidden-y-overflow');
}

//btnFecharOverlayAside.addEventListener('click', handleCloseSidebarOverlay)

checkCiente && checkCiente.addEventListener('change', handleToggleCiente)

/*abrirSidebarOverlay.forEach((btn) => {
  btn.addEventListener('click', handleOpenSidebarOverlay)
})*/

btnAbrirAjuda.forEach((btn) => {
    btn.addEventListener('click', handleOpenOverlayAjuda)
})

btnFecharOverlayAjuda.addEventListener('click', handleCloseSidebarAjuda)



document.querySelectorAll('.Servicos-Content-card').forEach(card => {
  const bgColor = card.getAttribute('data-bg-color');
  if (bgColor) {
      card.querySelector('.Servicos-Content-background .Servicos-Content-ring').style.setProperty('--bg-color', bgColor);
      card.querySelector('.Servicos-Content-background').style.setProperty('--bg-color', bgColor);
  }

  const iconColor = card.getAttribute('data-color');
  if (iconColor) {
      card.querySelector('.Servicos-Content-icon').style.backgroundColor = iconColor;
  }
});

document.querySelectorAll('.services-banner').forEach((banner) => {
  const imageUrl = banner.getAttribute('data-image');
  if (imageUrl) {
    banner.style.backgroundImage = `url(${imageUrl})`;
  }
});


/* Carrossel serviços */
const carrosseisServicos = Array.from(document.querySelectorAll("[data-js='servicos-carrossel']"));

if (carrosseisServicos.length > 0) {
    carrosseisServicos.forEach((item) => {
        new Swiper(item, {

            slidesPerView: 1,
            spaceBetween: 10,
            slidesPerView: 'auto',


            breakpoints: {
                320: {
                    spaceBetween: 20
                },
                480: {
                    spaceBetween: 10,
                },
            },

            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },

            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            }
        })
    })
}

document.querySelectorAll('.services-banner').forEach((banner) => {
  const imageUrl = banner.getAttribute('data-image');
  if (imageUrl) {
    banner.style.backgroundImage = `url(${imageUrl})`;
  }
});

document.querySelectorAll('.servicos-accordion__header').forEach((header) => {
  header.addEventListener('click', function () {
    const isExpanded = this.getAttribute('aria-expanded') === 'true';
    const icon = this.querySelector('.servicos-accordion__icon');

    setTimeout(() => {
      if (isExpanded) {
        icon.style.transform = 'rotate(90deg)';
      } else {
        icon.style.transform = 'rotate(270deg)';
      }
    }, 150);
  });
});

